import React from 'react'
import Styled from 'styled-components'
import TextareaAutosize from 'react-textarea-autosize'

export default Styled(
  ({ maxLines, ...props }) => <TextareaAutosize {...props} />
)`
  display: block;
  width: 100%;
  font-family: ${props => props.theme.fonts.regular};
  font-size: 1rem;
  line-height: 1.25;
  font-weight: normal;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.text};
  border: 0;
  border-top: 1px solid transparent;
  border-bottom: 1px solid ${props => props.theme.colors.gray.shade100};
  padding: 0.5rem 0;
  outline: none;
  resize: none;
  transition: border 300ms;

  &::placeholder {
    color: ${props => props.theme.colors.gray.shade100};
  }

  &:focus {
    outline: none;
    border-bottom-color: ${props => props.theme.colors.primary.shade400};
  }

  ${props => props.maxLines && `
    max-height: calc(1rem * 1.25 * ${props.maxLines});
  `}
`



// WEBPACK FOOTER //
// ./src/editor/TextField/index.js